export default __webpack_public_path__ + "static/media/location_map.fb5bdbf3.svg";